import { render, staticRenderFns } from "./BaseFreightCodeDisplay.vue?vue&type=template&id=3fe823d7"
import script from "./BaseFreightCodeDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseFreightCodeDisplay.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports